// Copyright (c) 2024 Deere & Company

import './factory-duplicate-pin-plate-result.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import FactoryPinPlate from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../shared/components/labeled-string';
import {Link} from 'react-router';
import {buildDate} from '../../../shared/services/build-date';
import {buildDealer} from '../../../shared/services/build-dealer';

class FactoryDuplicatePinPlateResult extends Component {

    constructor() {

        super();
        this.handleEdit = this.handleEdit.bind(this);

    }

    handleEdit() {

        const pinPlate = {...this.props.factoryDuplicatePinPlate};

        pinPlate.status = 'APPROVED';
        this.props.actions.updateDuplicatePinPlateStatus(pinPlate, this.props.selectedDealers);

    }

    render() {

        const {factoryDuplicatePinPlate} = this.props;
        const isApproved = factoryDuplicatePinPlate.status === 'APPROVED';

        return (
            <section className='spa-result'>
                <header>
                    <section className='spa-title'>
                        {isApproved && (
                        <div style={{display: 'inline-block', marginRight: '10px'}}>
                            <Checkbox
                                id={this.props.factoryDuplicatePinPlate.id}
                                onChange={() => this.props.onSelectChange(this.props.factoryDuplicatePinPlate.id, !this.props.factoryDuplicatePinPlate.selected)}
                                selected={this.props.factoryDuplicatePinPlate.selected || false}
                            >{''}</Checkbox>
                        </div>
                    )}
                        <span>
                            <Link
                                className='product-title'
                                rel='noopener noreferrer'
                                target='_blank'
                                to={`/products/${this.props.factoryDuplicatePinPlate.pin}`}
                            >
                                <FormattedMessage
                                    id={this.props.factoryDuplicatePinPlate.pin}
                                ></FormattedMessage>
                            </Link>
                        </span>

                    </section>
                </header>
                <div className='spa-details'>
                    <div className='row'>
                        <LabeledString
                            className='reference1'
                            data={this.props.factoryDuplicatePinPlate.machineModel}
                            label='MACHINE_MODEL_TYPE'
                        />
                        <LabeledString
                            className='pin'
                            data={this.props.factoryDuplicatePinPlate.pin}
                            label='PIN'
                        />
                        <LabeledString
                            className='customer-contribution'
                            data={buildDate(this.props.factoryDuplicatePinPlate.dateSubmmited)}
                            label='DATE_SUBMITTED'
                        />
                    </div>
                    <div className='row'>
                        <LabeledString
                            className='status-value'
                            data={this.props.factoryDuplicatePinPlate.status}
                            label='STATUS'
                        />
                        <LabeledString
                            className='submitted-date'
                            data={this.props.factoryDuplicatePinPlate.requesterTCSM}
                            label='REQUESTER_TCSM'
                        />
                        <LabeledString
                            className='dealer-contribution'
                            data={this.props.factoryDuplicatePinPlate.mailingRecipient}
                            label='RECIPIENT_MAILING'
                        />
                    </div>
                    <div className='row'>
                        <LabeledString
                            className='responsible-account lost-two-column'
                            data={buildDealer(this.props.factoryDuplicatePinPlate.dealer)}
                            label='RESPONSIBLE_DEALER'
                        />
                        <LabeledString
                            className='company-contribution'
                            data={this.props.factoryDuplicatePinPlate.factory}
                            label='FACTORY'
                        />
                    </div>
                    <div className='row'>
                        <LabeledString
                            className='created-by'
                            data={this.props.factoryDuplicatePinPlate.createdBy}
                            label='CREATED_BY'
                        />
                        <LabeledString
                            className='special-allowance-type-value lost-two-column'
                            data={this.props.factoryDuplicatePinPlate.missingPlateReason}
                            label='REASON_FOR_MISSING_PLATE'
                        />
                    </div>

                    <footer>
                        <section className='button-group'>
                            <Link
                                className='primary'
                                to={`/products/pin/plate/${encodeURIComponent(this.props.factoryDuplicatePinPlate.id)}`}
                            >
                                <FormattedMessage id='EDIT'/>
                            </Link>
                        </section>
                    </footer>

                </div>
            </section>
        );

    }
}

FactoryDuplicatePinPlateResult.displayName = 'FactoryDuplicatePinPlateResult';
FactoryDuplicatePinPlateResult.propTypes = {
    actions: PropTypes.object.isRequired,
    factoryDuplicatePinPlate: PropTypes.instanceOf(FactoryPinPlate).isRequired,
    onSelectChange: PropTypes.func,
    selectedDealers: PropTypes.arrayOf(PropTypes.string)
};

export default FactoryDuplicatePinPlateResult;



// WEBPACK FOOTER //
// ./src/product/factory-users-duplicate-pin-plate/components/factory-duplicate-pin-plate-result.js